import { render } from "./Tools.vue?vue&type=template&id=98a4d6bc"
import script from "./Tools.vue?vue&type=script&lang=js"
export * from "./Tools.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__